import { z } from "zod";

/**
 * GrupoAcessoFormSchema
 */

export const GrupoAcessoFormSchema = z.object({
  ativo: z.boolean().default(true),
  nomeGrupo: z.string().nonempty(),
  descricao: z.string().optional().nullable(),
  gestorGrupo: z.coerce.number().optional().nullable(), // idFuncionario

  idsAtribuicaoGrupo: z.array(z.object({
    idAtribuicao: z.coerce.number(),
  })).nullable().default(null),

});

export type GrupoAcessoForm = z.infer<typeof GrupoAcessoFormSchema>;

export const GrupoAcessoFormDefaultValues: GrupoAcessoForm = {
  ativo: true,
  nomeGrupo: "",
  descricao: null,
  gestorGrupo: null,

  idsAtribuicaoGrupo: [],

};